export const urduFlashcards = {
  categories: [
    {
      ur: "السلام علیکم",
      rm: "Assalam-o-Alaikum",
      en: "Peace be upon you (Islamic greeting)",
    },
    {
      ur: "وعلیکم السلام",
      rm: "Walaikum-Assalam",
      en: "And upon you be peace (response)",
    },
    {
      ur: "آداب",
      rm: "Aadaab",
      en: "Hello / Greetings (more formal)",
    },
    {
      ur: "ہیلو",
      rm: "Hello",
      en: "Hello (English loanword)",
    },
    {
      ur: "کیا حال ہے؟",
      rm: "Kya haal hai?",
      en: "How are you?",
    },
    {
      ur: "آپ کیسے ہیں؟",
      rm: "Aap kaise hain?",
      en: "How are you? (formal)",
    },
    {
      ur: "میں ٹھیک ہوں",
      rm: "Mein theek hun",
      en: "I am fine",
    },
    {
      ur: "شکریہ",
      rm: "Shukriya",
      en: "Thank you",
    },
    {
      ur: "بہت شکریہ",
      rm: "Bohat shukriya",
      en: "Thank you very much",
    },
    {
      ur: "مہربانی",
      rm: "Meherbani",
      en: "Thank you (formal)",
    },
    {
      ur: "کوئی بات نہیں",
      rm: "Koi baat nahi",
      en: "You're welcome / No problem",
    },
    {
      ur: "معاف کیجیے",
      rm: "Maaf kijiye",
      en: "Excuse me / Sorry",
    },
    {
      ur: "معاف کرنا",
      rm: "Maaf karna",
      en: "Forgive me",
    },
    {
      ur: "براہ مہربانی",
      rm: "Barah-e-meherbani",
      en: "Please",
    },
    {
      ur: "جی",
      rm: "Jee",
      en: "Yes (respectful)",
    },
    {
      ur: "ہاں",
      rm: "Haan",
      en: "Yes",
    },
    {
      ur: "نہیں",
      rm: "Nahi",
      en: "No",
    },
    {
      ur: "ٹھیک ہے",
      rm: "Theek hai",
      en: "Okay / Alright",
    },
    {
      ur: "میں نہیں سمجھتا",
      rm: "Mein nahi samajhta",
      en: "I don't understand (male)",
    },
    {
      ur: "میں نہیں سمجھتی",
      rm: "Mein nahi samajhti",
      en: "I don't understand (female)",
    },
    {
      ur: "کیا آپ انگریزی بولتے ہیں؟",
      rm: "Kya aap angrezi bolte hain?",
      en: "Do you speak English? (formal)",
    },
    {
      ur: "کیا تم انگریزی بولتے ہو؟",
      rm: "Kya tum angrezi bolte ho?",
      en: "Do you speak English? (informal - to male)",
    },
    {
      ur: "کیا تم انگریزی بولتی ہو؟",
      rm: "Kya tum angrezi bolti ho?",
      en: "Do you speak English? (informal - to female)",
    },
    {
      ur: "یہ کیا ہے؟",
      rm: "Yeh kya hai?",
      en: "What is this?",
    },
    {
      ur: "یہ کتنے کا ہے؟",
      rm: "Yeh kitne ka hai?",
      en: "How much is this?",
    },
    {
      ur: "کہاں ہے؟",
      rm: "Kahan hai?",
      en: "Where is...?",
    },
    {
      ur: "باتھ روم کہاں ہے؟",
      rm: "Bathroom kahan hai?",
      en: "Where is the bathroom? (English loanword)",
    },
    {
      ur: "غسل خانہ کہاں ہے؟",
      rm: "Ghusl khana kahan hai?",
      en: "Where is the bathroom? (more traditional)",
    },
    {
      ur: "ریلوے اسٹیشن کہاں ہے؟",
      rm: "Railway station kahan hai?",
      en: "Where is the railway station?",
    },
    {
      ur: "ایئرپورٹ کہاں ہے؟",
      rm: "Airport kahan hai?",
      en: "Where is the airport?",
    },
    {
      ur: "مدد کریں!",
      rm: "Madad karein!",
      en: "Help!",
    },
    {
      ur: "مجھے مدد چاہیے",
      rm: "Mujhe madad chahiye",
      en: "I need help",
    },
    {
      ur: "میں کھو گیا ہوں",
      rm: "Mein kho gaya hun",
      en: "I am lost (male)",
    },
    {
      ur: "میں کھو گئی ہوں",
      rm: "Mein kho gayi hun",
      en: "I am lost (female)",
    },
    {
      ur: "کیا آپ میری مدد کر سکتے ہیں؟",
      rm: "Kya aap meri madad kar sakte hain?",
      en: "Can you help me?",
    },
    {
      ur: "آہستہ بولیں",
      rm: "Ahista bolein",
      en: "Speak slowly",
    },
    {
      ur: "پھر سے بولیں",
      rm: "Phir se bolein",
      en: "Say it again",
    },
    {
      ur: "میں بیمار ہوں",
      rm: "Mein bimar hun",
      en: "I am sick",
    },
    {
      ur: "مجھے ڈاکٹر چاہیے",
      rm: "Mujhe doctor chahiye",
      en: "I need a doctor",
    },
    {
      ur: "یہ بہت مہنگا ہے",
      rm: "Yeh bohat mehanga hai",
      en: "This is too expensive",
    },
    {
      ur: "کیا آپ کم کر سکتے ہیں؟",
      rm: "Kya aap kam kar sakte hain?",
      en: "Can you lower the price?",
    },
    {
      ur: "مجھے یہ چاہیے",
      rm: "Mujhe yeh chahiye",
      en: "I want this",
    },
    {
      ur: "مجھے یہ نہیں چاہیے",
      rm: "Mujhe yeh nahi chahiye",
      en: "I don't want this",
    },
    {
      ur: "میرا نام... ہے",
      rm: "Mera naam... hai",
      en: "My name is...",
    },
    {
      ur: "آپ کا نام کیا ہے؟",
      rm: "Aap ka naam kya hai?",
      en: "What is your name? (formal)",
    },
    {
      ur: "تمھارا نام کیا ہے؟",
      rm: "Tumhara naam kya hai?",
      en: "What is your name? (informal)",
    },
    {
      ur: "میں ٹھیک ہوں، شکریہ",
      rm: "Mein theek hun, shukriya",
      en: "I am fine, thank you",
    },
    {
      ur: "اچھا",
      rm: "Achha",
      en: "Good / Okay",
    },
    {
      ur: "بہت اچھا",
      rm: "Bohat achha",
      en: "Very good",
    },
    {
      ur: "برا",
      rm: "Bura",
      en: "Bad",
    },
    {
      ur: "صبح بخیر",
      rm: "Subah bakhair",
      en: "Good morning",
    },
    {
      ur: "شب بخیر",
      rm: "Shab bakhair",
      en: "Good night",
    },
    {
      ur: "خدا حافظ",
      rm: "Khuda hafiz",
      en: "Goodbye (Islamic)",
    },
    {
      ur: "پھر ملیں گے",
      rm: "Phir milein ge",
      en: "See you again",
    },
    {
      ur: "دائیں",
      rm: "Daein",
      en: "Right",
    },
    {
      ur: "بائیں",
      rm: "Baein",
      en: "Left",
    },
    {
      ur: "سیدھے",
      rm: "Seedhe",
      en: "Straight",
    },
    {
      ur: "اوپر",
      rm: "Upar",
      en: "Up",
    },
    {
      ur: "نیچے",
      rm: "Neeche",
      en: "Down",
    },
    {
      ur: "قریب",
      rm: "Qareeb",
      en: "Near",
    },
    {
      ur: "دور",
      rm: "Door",
      en: "Far",
    },
    {
      ur: "آج",
      rm: "Aaj",
      en: "Today",
    },
    {
      ur: "کل",
      rm: "Kal",
      en: "Tomorrow / Yesterday (context matters)",
    },
    {
      ur: "ابھی",
      rm: "Abhi",
      en: "Now",
    },
    {
      ur: "بعد میں",
      rm: "Baad mein",
      en: "Later",
    },
    {
      ur: "پانی",
      rm: "Pani",
      en: "Water",
    },
    {
      ur: "کھانا",
      rm: "Khana",
      en: "Food",
    },
    {
      ur: "چائے",
      rm: "Chai",
      en: "Tea",
    },
    {
      ur: "کافی",
      rm: "Coffee",
      en: "Coffee",
    },
    {
      ur: "کیا یہ حلال ہے؟",
      rm: "Kya yeh halal hai?",
      en: "Is this halal?",
    },
    {
      ur: "مجھے بھوک لگی ہے",
      rm: "Mujhe bhook lagi hai",
      en: "I am hungry",
    },
    {
      ur: "مجھے پیاس لگی ہے",
      rm: "Mujhe pyas lagi hai",
      en: "I am thirsty",
    },
    {
      ur: "کتنا وقت لگے گا؟",
      rm: "Kitna waqt lage ga?",
      en: "How much time will it take?",
    },
    {
      ur: "پاسپورٹ",
      rm: "Passport",
      en: "Passport",
    },
    {
      ur: "ویزا",
      rm: "Visa",
      en: "Visa",
    },
    {
      ur: "ہوٹل",
      rm: "Hotel",
      en: "Hotel",
    },
    {
      ur: "کمرہ",
      rm: "Kamra",
      en: "Room",
    },
    {
      ur: "میں ایک کمرہ بک کرنا چاہتا ہوں",
      rm: "Mein ek kamra book karna chahta hun (m)",
      en: "I want to book a room (male)",
    },
    {
      ur: "میں ایک کمرہ بک کرنا چاہتی ہوں",
      rm: "Mein ek kamra book karna chahti hun (f)",
      en: "I want to book a room (female)",
    },
    {
      ur: "یہ بہت اچھا ہے",
      rm: "Yeh bohat achha hai",
      en: "This is very good",
    },
    {
      ur: "کوئی مسئلہ نہیں",
      rm: "Koi masla nahi",
      en: "No problem",
    },
    {
      ur: "مبارک ہو!",
      rm: "Mubarak ho!",
      en: "Congratulations!",
    },
    {
      ur: "نیک خواہشات",
      rm: "Naik khwahishat",
      en: "Best wishes",
    },
    {
      ur: "مزے کرو!",
      rm: "Maze karo!",
      en: "Have fun!",
    },
    {
      ur: "تشریف لائیے",
      rm: "Tashreef laiye",
      en: "Please come in (formal)",
    },
    {
      ur: "ادھر آئیں",
      rm: "Idhar aaein",
      en: "Come here",
    },
    {
      ur: "بیٹھیں",
      rm: "Baithein",
      en: "Please sit (formal)",
    },
    {
      ur: "دیکھیں",
      rm: "Dekhein",
      en: "Look",
    },
    {
      ur: "جلدی کرو",
      rm: "Jaldi karo",
      en: "Hurry up!",
    },
  ],
};
